import { useState } from "react";
import EmojiPicker, { EmojiStyle, Theme } from "emoji-picker-react";
import { Smile } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

// Emojis thématiques naturopathie
export const NATUROPATHY_EMOJIS = [
  '🌿','🌱','🌾','🌻','🌸','🌺','🌷','🌹','🌼','💐',
  '🍃','🍀','🌳','🌲','🌴','🪴','🌵','🌰','🌽','🥬',
  '🥦','🥕','🍋','🍊','🍎','🍏','🍇','🍓','🫐','🥥',
  '🍯','🫖','🍵','🧘‍♀️','🧘','🧘‍♂️','💆‍♀️','💆','🫧','💧',
  '🌞','☀️','🌙','⭐','✨','🌈','🔥','💚','💛','🤎',
  '🧴','🧂','🥄','🍽️','🍶','🌍','🦋','🐝','🐞','🦔',
];

interface EmojiPickerPopoverProps {
  onSelect: (emoji: string) => void;
  triggerLabel?: string;
  variant?: "button" | "icon";
  align?: "start" | "center" | "end";
}

export function EmojiPickerPopover({ onSelect, triggerLabel, variant = "icon", align = "start" }: EmojiPickerPopoverProps) {
  const [open, setOpen] = useState(false);

  const handle = (e: string) => {
    onSelect(e);
    // garde ouvert pour permettre plusieurs sélections rapides
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {variant === "icon" ? (
          <Button type="button" variant="outline" size="sm" className="gap-1.5">
            <Smile className="w-4 h-4" />
            {triggerLabel || "Emoji"}
          </Button>
        ) : (
          <Button type="button" variant="ghost" size="icon" aria-label="Emojis">
            <Smile className="w-4 h-4" />
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent align={align} className="w-[340px] p-2">
        <Tabs defaultValue="nature">
          <TabsList className="grid grid-cols-2 w-full">
            <TabsTrigger value="nature">🌿 Naturopathie</TabsTrigger>
            <TabsTrigger value="all">😀 Tous</TabsTrigger>
          </TabsList>
          <TabsContent value="nature" className="mt-2">
            <div className="grid grid-cols-8 gap-1 max-h-[280px] overflow-y-auto">
              {NATUROPATHY_EMOJIS.map((e, i) => (
                <button
                  key={`${e}-${i}`}
                  type="button"
                  onClick={() => handle(e)}
                  className="text-xl p-1.5 rounded hover:bg-muted transition-colors"
                  aria-label={`Insérer ${e}`}
                >
                  {e}
                </button>
              ))}
            </div>
          </TabsContent>
          <TabsContent value="all" className="mt-2">
            <EmojiPicker
              onEmojiClick={(d) => handle(d.emoji)}
              theme={Theme.AUTO}
              emojiStyle={EmojiStyle.NATIVE}
              width="100%"
              height={320}
              searchPlaceholder="Rechercher un emoji..."
              previewConfig={{ showPreview: false }}
              skinTonesDisabled
            />
          </TabsContent>
        </Tabs>
      </PopoverContent>
    </Popover>
  );
}
